import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../Customize_Css/Pagination.css';
import '../Customize_Css/ViewCategoryImage.css';
import '../Customize_Css/ViewProductImageModal.css';
import { useNavigate } from 'react-router-dom';
import { Dropdown, Table, Modal, Button,Form } from 'react-bootstrap';
import { FaTrashAlt, FaFileExport, FaEdit } from 'react-icons/fa';
import Sidebar from '../Components/Siderbar';
import Footer from '../Components/Footer';
import { toast } from 'react-toastify';
import axios from 'axios';
import * as XLSX from 'xlsx';

const ViewProductImage = () => {
    const navigate = useNavigate();
    const epicxTenantId = localStorage.getItem('epicxTenantId');
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const AuthorizationToken = localStorage.getItem('token');
    const [data, setData] = useState([]);
    const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
    const [searchTerm, setSearchTerm] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(10);
    const [selectedItems, setSelectedItems] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [useFileUpload, setUseFileUpload] = useState(false);
    const [categoryNames, setCategoryNames] = useState([]);
    const [editSubCategory, setEditSubCategory] = useState({ categoryName: '', categoryId: '' });
    
    const [subCategoryNames, setSubCategoryNames] = useState([]);
    const [productDetails, setProductDetails] = useState({});
    // Image editing states
    const [images, setImages] = useState([]);               
    const [newImages, setNewImages] = useState([]);        
    const [newImageFiles, setNewImageFiles] = useState([]); 
    const [editMode, setEditMode] = useState(false);
    // Fetch Products
    useEffect(() => {
      const fetchCategories = async () => {
        try {
          const response = await axios.get(`${BASE_URL}/products/api/category/${epicxTenantId}`, {
            headers: {
              Authorization: `Bearer ${AuthorizationToken}`,
            },
          });
          setCategoryNames(response.data.categories);
          
        } catch (error) {
          console.error('Error fetching categories:', error);
        }
      };
    
      fetchCategories();
    }, [BASE_URL, AuthorizationToken, epicxTenantId]);
    
    const fetchProducts = async () => {
        try {
            const response = await axios.get(`${BASE_URL}/products/api/products/${epicxTenantId}/all`,
                {
                    headers: {
                        Authorization: `Bearer ${AuthorizationToken}`,
                      },
                    }
            );
            setData(response.data);
        } catch (error) {
            console.error('Error fetching products:', error);
            toast.error(`Error fetching products: ${error.message}`);
        }
    };

    useEffect(() => {
        fetchProducts();
    }, []);

    // Sorting 
    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
        setData((prevData) => {
            return [...prevData].sort((a, b) => {
                let aValue = a[key];
                let bValue = b[key];

                if (typeof aValue === 'string') {
                    aValue = aValue.toLowerCase();
                    bValue = bValue.toLowerCase();
                }

                if (aValue < bValue) {
                    return direction === 'asc' ? -1 : 1;
                }
                if (aValue > bValue) {
                    return direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        });
    };

    // Search 
    const handleSearch = (value) => {
        setSearchTerm(value.toLowerCase());
        if (value === '') {
            fetchProducts();
            return;
        }
        const filteredData = data.filter((item) =>
            Object.keys(item).some((key) =>
                item[key]?.toString().toLowerCase().includes(value.toLowerCase())
            )
        );
        setData(filteredData);
        setCurrentPage(1); 
    };

    // Select/Deselect all items
    const handleSelectAll = () => {
        if (selectedItems.length === data.length) {
            setSelectedItems([]);
        } else {
            setSelectedItems(data.map(item => item._id));
        }
    };

    // Select individual item
    const handleSelectItem = (_id) => {
        if (selectedItems.includes(_id)) {
            setSelectedItems(selectedItems.filter(item => item !== _id));
        } else {
            setSelectedItems([...selectedItems, _id]);
        }
    };

    // Delete 
    const handleDelete = async () => {
        if (selectedItems.length === 0) {
            toast.warn("No items selected to delete");
            return;
        }

        const confirmed = window.confirm("Are you sure you want to delete the selected products?");
        if (!confirmed) return;

        try {
            for (const itemId of selectedItems) {
                await axios.put(`${BASE_URL}/products/api/products/${epicxTenantId}/delete/${itemId}`,
                     {},
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                          },
                        }
                );
                console.log(`Product with id ${itemId} deleted`);
            }
            fetchProducts(); 
            setSelectedItems([]);
            toast.success("Selected products deleted successfully!");
        } catch (error) {
            console.error("Error deleting products:", error);
            toast.error("Error deleting products. Please try again.");
        }
    };
   const handleDeleteImage = (event, index, isNew) => {
        event.preventDefault();
        event.stopPropagation();
        if (isNew) {
            setNewImages(prev => prev.filter((_, i) => i !== index));
            setNewImageFiles(prev => prev.filter((_, i) => i !== index));
        } else {
            setImages(prev => prev.filter((_, i) => i !== index));
        }
    };

    const handleToggleChange = () => {
        setEditMode(!editMode);
        if (!editMode) {
            setNewImages([]);
            setNewImageFiles([]);
        }
    };

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files || []);
        const remaining = 10 - newImages.length;
        if (remaining <= 0 || files.length > remaining) {
            toast.warning('You can add up to 10 new images');
            e.target.value = '';
            return;
        }
        const previews = files.map(file => URL.createObjectURL(file));
        setNewImages(prev => [...prev, ...previews]);
        setNewImageFiles(prev => [...prev, ...files]);
        e.target.value = '';
    };

    const handleEdit = async () => {
        if (selectedItems.length !== 1) return toast.warn("Select exactly one product to edit");

        const productId = selectedItems[0];
        try {
            const res = await axios.get(`${BASE_URL}/products/api/products/${epicxTenantId}/${productId}`, {
                headers: { Authorization: `Bearer ${AuthorizationToken}` },
            });
            const product = res.data;
            setProductDetails(product);
            setImages(product.productImages || []);
            setNewImages([]);
            setNewImageFiles([]);
            setEditMode(false);
            const matchedCategory = categoryNames.find(
                (category) => category.categoryName === product.categoryName
            );
            setEditSubCategory({
                categoryName: product.categoryName || '',
                categoryId: product.categoryId || matchedCategory?._id || '',
            });
            setSelectedProduct(productId);
            setShowModal(true);
        } catch (error) {
            toast.error("Error loading product details");
        }
    };
    const handleExport = () => {
        const dataToExport = selectedItems.length > 0 
            ? data.filter(item => selectedItems.includes(item._id)) 
            : data;
        const exportData = dataToExport.map(item => ({
            productName: item.productName,
            productType: item.productType,
            categoryName:item.categoryName,
            vegOrNonVeg: item.vegOrNonVeg,
            createdAt: item.createdAt,
        }));
        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "ProductImages");
        XLSX.writeFile(wb, 'ProductImages_data.xlsx');
    };

    const handleSubmitEdit = async () => {
        const formData = new FormData();

        formData.append('productName', productDetails.productName || '');
        formData.append('categoryName', editSubCategory.categoryName || '');
        formData.append('categoryId', editSubCategory.categoryId || '');
        const matchedSubCategory = subCategoryNames.find(
            (sub) => sub.subCategoryName === productDetails.subCategoryName
        );
        formData.append('subCategoryName', matchedSubCategory ? matchedSubCategory.subCategoryName : '');

        // Keep existing images
        images.forEach((url, i) => {
            formData.append(`existingImage_${i}`, url);
        });

        // Add new images
        newImageFiles.forEach((file, i) => {
            formData.append(`productImage_${i}`, file);
        });

        try {
            await axios.put(`${BASE_URL}/products/api/products/${epicxTenantId}/${selectedProduct}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${AuthorizationToken}`,
                },
            });

            toast.success('Product updated successfully!');
            setShowModal(false);
            fetchProducts();
        } catch (error) {
            console.error('Update error:', error);
            toast.error('Failed to update product');
        }
    };
    
    const handleImageToggle = () => {
        setUseFileUpload((prev) => !prev);
        setProductDetails((prevDetails) => ({
            ...prevDetails,
            productImage: '', 
        }));
    };
    // Pagination
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = data.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(data.length / itemsPerPage);

    useEffect(() => {
        if (!editSubCategory.categoryId) {
            setSubCategoryNames([]);
            return;
        }

        let cancelled = false;
        const fetchSubCategories = async () => {
            try {
                const response = await axios.get(
                    `${BASE_URL}/products/api/sub-category/${epicxTenantId}/subCategoryNames/${editSubCategory.categoryId}`,
                    {
                        headers: {
                            Authorization: `Bearer ${AuthorizationToken}`,
                        },
                    }
                );
                const list = Array.isArray(response.data) ? response.data : [];
                if (cancelled) return;
                setSubCategoryNames(list);
                setProductDetails((prev) => {
                    const stillValid = list.some((sub) => sub.subCategoryName === prev.subCategoryName);
                    return stillValid ? prev : { ...prev, subCategoryName: '' };
                });
            } catch (error) {
                if (cancelled) return;
                console.error('Error fetching subcategories:', error);
                setSubCategoryNames([]);
                setProductDetails((prev) => ({ ...prev, subCategoryName: '' }));
            }
        };

        fetchSubCategories();
        return () => {
            cancelled = true;
        };
    }, [editSubCategory.categoryId, BASE_URL, AuthorizationToken, epicxTenantId]);

   const handleCategorySelect = (category) => {
        const sameCategory = String(category._id) === String(editSubCategory.categoryId);
        setEditSubCategory({ categoryName: category.categoryName, categoryId: category._id });
        setProductDetails((prev) => ({
            ...prev,
            categoryName: category.categoryName,
            subCategoryName: sameCategory ? prev.subCategoryName : '',
        }));
        if (!sameCategory) {
            setSubCategoryNames([]);
        }
    };
    const handleSubCategorySelect = (subCategory) => {
        setProductDetails(prev => ({ ...prev, subCategoryName: subCategory.subCategoryName }));
    };

    const handleInputChange = (e) => {
        setProductDetails({
            ...productDetails,
            [e.target.name]: e.target.value,
        });
    };
    const productColumns = [
        { key: 'productName', label: 'Product Name' },
        { key: 'productType', label: 'Product Type' },
        { key: 'categoryName', label: 'Category Name' },
        { key: 'subCategoryName', label: 'Sub Category Name' },
        { key: 'vegOrNonVeg', label: 'Veg Or Non Veg' },
        { key: 'productImage', label: 'Product Image' },
    ];

    return (
        <>
            <Sidebar />
            <div className="category-list-page">
                <div className="category-list-top">
                    <div>
                        <button
                            type="button"
                            className="category-back"
                            onClick={() => navigate('/Add-product-image')}
                        >
                            ← Back
                        </button>
                        <h1>Product Images List</h1>
                        <p className="category-lead">Saved product photos. Search, sort, or use Action to edit, delete, or export.</p>
                    </div>
                    <div className="category-list-tools">
                        <input
                            type="text"
                            className="form-control category-search"
                            placeholder="Search..."
                            value={searchTerm}
                            onChange={(e) => handleSearch(e.target.value)}
                        />
                        <Dropdown>
                            <Dropdown.Toggle className="category-action">
                                Action
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                                <Dropdown.Item onClick={handleDelete}>
                                    <FaTrashAlt className="me-2" /> Delete
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleEdit}>
                                    <FaEdit className="me-2" /> Edit
                                </Dropdown.Item>
                                <Dropdown.Item onClick={handleExport}>
                                    <FaFileExport className="me-2" /> Export
                                </Dropdown.Item>
                            </Dropdown.Menu>
                        </Dropdown>
                    </div>
                </div>
                <div className="category-list-card">
                    <div className="category-list-scroll">
                        <Table hover responsive className="category-table wide-table">
                            <thead>
                                <tr>
                                    <th style={{ width: '52px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedItems.length === data.length && data.length > 0}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    {productColumns.map((column) => (
                                        <th
                                            key={column.key}
                                            onClick={() => handleSort(column.key)}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {column.label}
                                            {sortConfig.key === column.key ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼') : ''}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {currentData.map((item) => (
                                    <tr key={item._id} className={selectedItems.includes(item._id) ? 'selected-row' : ''}>
                                        <td>
                                            <input
                                                type="checkbox"
                                                checked={selectedItems.includes(item._id)}
                                                onChange={() => handleSelectItem(item._id)}
                                            />
                                        </td>
                                        <td>{item.productName || 'N/A'}</td>
                                        <td>{item.productType || 'N/A'}</td>
                                        <td>{item.categoryName || 'N/A'}</td>
                                        <td>{item.subCategoryName || 'N/A'}</td>
                                        <td>{item.vegOrNonVeg || 'N/A'}</td>
                                        <td>
                                            {item.productImages && item.productImages.length > 0 ? (
                                                <img
                                                    src={item.productImages[0]}
                                                    alt={item.productName}
                                                    className="category-thumb"
                                                />
                                            ) : 'No Image'}
                                        </td>
                                    </tr>
                                ))}
                                {currentData.length === 0 && (
                                    <tr>
                                        <td colSpan="7" className="category-empty">
                                            No product images found.
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                    <div className="category-list-footer">
                        <span className="category-total">
                            {`Total Product Images: ${data.length}`}
                        </span>
                        <ul className="category-pager">
                            <li>
                                <button type="button" onClick={() => setCurrentPage(1)} disabled={currentPage === 1}>«</button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                                    disabled={currentPage === 1}
                                >
                                    ‹
                                </button>
                            </li>
                            <li>
                                <button type="button" className="is-active">{currentPage}</button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages || 1))}
                                    disabled={currentPage === totalPages || totalPages === 0}
                                >
                                    ›
                                </button>
                            </li>
                            <li>
                                <button
                                    type="button"
                                    onClick={() => setCurrentPage(totalPages || 1)}
                                    disabled={currentPage === totalPages || totalPages === 0}
                                >
                                    »
                                </button>
                            </li>
                        </ul>
                    </div>
                </div>

            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered className="pie-modal">
                <Modal.Header closeButton>
                    <button
                        type="button"
                        className="category-back edit-back"
                        onClick={() => setShowModal(false)}
                    >
                        ← Back
                    </button>
                    <Modal.Title>Edit Product Image</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={(event) => event.preventDefault()}>
                        <Form.Group className="mb-3">
                            <Form.Label className="pie-field-label">Product Name</Form.Label>
                            <Form.Control
                                className="pie-input"
                                type="text"
                                value={productDetails.productName || ''}
                                onChange={(e) => setProductDetails({ ...productDetails, productName: e.target.value })}
                            />
                        </Form.Group>

                        <div className="row">
                            <Form.Group className="col-md-6 mb-3">
                                <Form.Label className="pie-field-label">Category Name</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" className="pie-select">
                                        {editSubCategory.categoryName || 'Select a category'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {categoryNames.map(cat => (
                                            <Dropdown.Item key={cat._id} onClick={() => handleCategorySelect(cat)}>
                                                {cat.categoryName}
                                            </Dropdown.Item>
                                        ))}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>

                            <Form.Group className="col-md-6 mb-3">
                                <Form.Label className="pie-field-label">Sub Category Name</Form.Label>
                                <Dropdown>
                                    <Dropdown.Toggle variant="light" className="pie-select" disabled={!editSubCategory.categoryId}>
                                        {productDetails.subCategoryName || 'Select a subcategory'}
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        {subCategoryNames.length === 0 ? (
                                            <Dropdown.Item disabled>No subcategories for this category</Dropdown.Item>
                                        ) : (
                                            subCategoryNames.map(sub => (
                                                <Dropdown.Item key={sub._id} onClick={() => handleSubCategorySelect(sub)}>
                                                    {sub.subCategoryName}
                                                </Dropdown.Item>
                                            ))
                                        )}
                                    </Dropdown.Menu>
                                </Dropdown>
                            </Form.Group>
                        </div>

                        <div className="pie-images">
                            <div className="pie-images-head">
                                <Form.Label className="pie-field-label mb-0">Product Images</Form.Label>
                                <span className="pie-count">{images.length} saved</span>
                            </div>
                            <p className="pie-hint">Use the remove button on a photo, then save. The picture stays until you update.</p>
                            {images.length === 0 ? (
                                <p className="pie-empty">No images yet. Turn on add images below to upload some.</p>
                            ) : (
                                <div className="pie-grid">
                                    {images.map((img, idx) => (
                                        <div key={`${img}-${idx}`} className="pie-card">
                                            <img src={img} alt={`Product ${idx + 1}`} />
                                            <button
                                                type="button"
                                                className="pie-remove"
                                                aria-label={`Remove image ${idx + 1}`}
                                                onClick={(event) => handleDeleteImage(event, idx, false)}
                                            >
                                                ×
                                            </button>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>

                        <div className="pie-add-row">
                            <div>
                                <div className="pie-field-label mb-0">Add images</div>
                                <p className="pie-hint mb-0">Upload up to 10 new photos for this product.</p>
                            </div>
                            <Form.Check
                                type="switch"
                                id="editImagesSwitch"
                                checked={editMode}
                                onChange={handleToggleChange}
                            />
                        </div>

                        {editMode && (
                            <div className="pie-upload">
                                <Form.Label className="pie-field-label">Choose images</Form.Label>
                                <Form.Control
                                    type="file"
                                    multiple
                                    accept="image/*"
                                    onChange={handleFileChange}
                                />
                                {newImages.length > 0 && (
                                    <div className="pie-grid pie-grid-new">
                                        {newImages.map((preview, idx) => (
                                            <div key={`new-${idx}`} className="pie-card">
                                                <img src={preview} alt={`New ${idx + 1}`} />
                                                <button
                                                    type="button"
                                                    className="pie-remove"
                                                    aria-label={`Remove new image ${idx + 1}`}
                                                    onClick={(event) => handleDeleteImage(event, idx, true)}
                                                >
                                                    ×
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        )}
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                    <Button className="pie-close" onClick={() => setShowModal(false)}>
                        Back
                    </Button>
                    <Button className="pie-save" onClick={handleSubmitEdit}>
                        Update Product Image
                    </Button>
                </Modal.Footer>
            </Modal>
                <Footer />
            </div>
        </>
    );
};

export default ViewProductImage;
